import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css";
import "toastr/build/toastr.min.css";
import "tom-select/dist/css/tom-select.bootstrap5.css";
import "cropperjs/dist/cropper.css";
import "../css/admin-lte.scss"

import "bootstrap"
import "admin-lte"
import toastr from "toastr";

import { Application } from '@hotwired/stimulus';
import datatableController from './controllers/datatable_controller';
import notificationController from './controllers/notification_controller';
import imagePreviewController from './controllers/image-preview_controller';
import birthdayCalendarController from './controllers/birthday-calendar_controller';
import Autocomplete from '@symfony/ux-autocomplete';
import TagsSchedule from './controllers/tags_schedule_controller';
import TomSelectColorsController from './controllers/tom_select_colors_controller';
import TagFormController from './controllers/tag_form_controller';
import FormCollectionController from './controllers/form_collection_controller';
import DropzoneController from './controllers/dropzone_controller';
import ReminderController from './controllers/reminder_controller';
import ConfirmController from './controllers/confirm_controller';
import SavedFiltersController from './controllers/saved_filters_controller';
import NotificationUsersController from './controllers/notification_users_controller';
import BulkActionsController from './controllers/bulk_actions_controller';
import ChildrenReportController from './controllers/children_report_controller';
import ChildPhotosController from './controllers/child-photos_controller';
import UserPermissionsController from './controllers/user-permissions_controller';
import PasswordValidatorController from './controllers/password-validator_controller';
import SedeItemsController from './controllers/sede-items_controller';
import CongregatioController from './controllers/congregatio_controller';
import DatepickerController from './controllers/datepicker_controller';
import GoogleMapsController from './controllers/google_maps_controller';
import SelectSearchController from './controllers/select_search_controller';
import VisitController from './controllers/visit_controller';
import AddressController from './controllers/address_controller';
import RegisterEmailController from './controllers/register_email_controller';
import PhoneController from './controllers/phone_controller';
import ModalFormController from './controllers/modal-form_controller';
import SedeCurrencyController from './controllers/sede-currency_controller';
import RevealFieldController from './controllers/reveal-field_controller';
import DatosBancariosController from './controllers/datos-bancarios_controller';
import ImageCropperController from './controllers/image-cropper_controller';
import InactiveReasonController from './controllers/inactive-reason_controller';

const app = Application.start();
// register any custom, 3rd party controllers here
app.register('datatable', datatableController);
app.register('image-preview', imagePreviewController);
app.register('birthday-calendar', birthdayCalendarController);
app.register('notification', notificationController);
app.register('image-cropper', ImageCropperController);
app.register('inactive-reason', InactiveReasonController);
app.register(
    'symfony--ux-autocomplete--autocomplete',
    Autocomplete
);
app.register('tags-schedule', TagsSchedule);
app.register('tom-select-colors', TomSelectColorsController);
app.register('tag-form', TagFormController);
app.register('form-collection', FormCollectionController);
app.register('dropzone', DropzoneController);
app.register('reminder', ReminderController);
app.register('confirm', ConfirmController);
app.register('saved-filters', SavedFiltersController);
app.register('notification-users', NotificationUsersController);
app.register('bulk-actions', BulkActionsController);
app.register('children-report', ChildrenReportController);
app.register('child-photos', ChildPhotosController);
app.register('user-permissions', UserPermissionsController);
app.register('password-validator', PasswordValidatorController);
app.register('sede-items', SedeItemsController);
app.register('congregatio', CongregatioController);
app.register('datepicker', DatepickerController);
app.register('google-maps', GoogleMapsController);
app.register('select-search', SelectSearchController);
app.register('visit', VisitController);
app.register('address', AddressController);
app.register('register-email', RegisterEmailController);
app.register('phone', PhoneController);
app.register('modal-form', ModalFormController);
app.register('sede-currency', SedeCurrencyController);
app.register('reveal-field', RevealFieldController);
app.register('datos-bancarios', DatosBancariosController);

window.toastr = toastr;
